export default class SelectContentsChange {
  constructor() {
    this.setup();
  }
  setup() {
    const wrap = document.getElementsByClassName('js-contentsChange');
    if (wrap) {
      for (let i = 0; i < wrap.length; i++) {
        const select = wrap[i].getElementsByClassName('js-contentsChange-select');
        const contents = wrap[i].getElementsByClassName('js-contentsChange-contents');
        for (let i = 0; i < select.length; i++) {
          select[i].addEventListener('change', function() {
            const val = this.value;
            for (let i = 0; i < contents.length; i++) {
              contents[i].classList.remove('active');
            }
            document.getElementById(val).classList.add('active');
          });
        }
      }
    }
  }
}
